/**
 * The URL is the state.
 *
 * Both chart screens read their window (and Tenants its selected tenant) from
 * the query string and write it back with `replaceState`, so a zoomed window or
 * a single tenant pasted into a chat opens on exactly that view, and the back
 * button is not filled with every drag of a range handle.
 *
 * `pathname` is preserved rather than rebuilt, which is what lets the same code
 * work under `/preview?tab=tenants` as under `/tenants`.
 */
export const readParams = () => new URLSearchParams(window.location.search);

export const writeUrl = (params: URLSearchParams) => {
  const query = params.toString();
  window.history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
};

/** Set when there is a value, delete when there is not — never `?tenant=`. */
export const withParam = (params: URLSearchParams, key: string, value: string | null): URLSearchParams => {
  const next = new URLSearchParams(params);
  if (value) next.set(key, value);
  else next.delete(key);
  return next;
};
